var moduleMap = {
	"./alertComponent": function() {
		return Promise.all(/* __federation_expose_alertComponent */[__webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(703)]).then(function() { return function() { return (__webpack_require__(7784)); }; });
	},
	"./buttonComponent": function() {
		return Promise.all(/* __federation_expose_buttonComponent */[__webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(49)]).then(function() { return function() { return (__webpack_require__(3446)); }; });
	},
	"./headerComponent": function() {
		return Promise.all(/* __federation_expose_headerComponent */[__webpack_require__.e(308), __webpack_require__.e(119), __webpack_require__.e(349), __webpack_require__.e(579), __webpack_require__.e(51), __webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(486), __webpack_require__.e(297), __webpack_require__.e(880)]).then(function() { return function() { return (__webpack_require__(5051)); }; });
	},
	"./formComponent": function() {
		return Promise.all(/* __federation_expose_formComponent */[__webpack_require__.e(119), __webpack_require__.e(349), __webpack_require__.e(579), __webpack_require__.e(802), __webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(486), __webpack_require__.e(943)]).then(function() { return function() { return (__webpack_require__(6932)); }; });
	},
	"./tableComponent": function() {
		return Promise.all(/* __federation_expose_tableComponent */[__webpack_require__.e(935), __webpack_require__.e(119), __webpack_require__.e(349), __webpack_require__.e(579), __webpack_require__.e(802), __webpack_require__.e(345), __webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(486), __webpack_require__.e(9), __webpack_require__.e(977)]).then(function() { return function() { return (__webpack_require__(9205)); }; });
	},
	"./panelFormComponent": function() {
		return Promise.all(/* __federation_expose_panelFormComponent */[__webpack_require__.e(119), __webpack_require__.e(349), __webpack_require__.e(579), __webpack_require__.e(802), __webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(486), __webpack_require__.e(9), __webpack_require__.e(5)]).then(function() { return function() { return (__webpack_require__(4009)); }; });
	},
	"./loginComponent": function() {
		return Promise.all(/* __federation_expose_loginComponent */[__webpack_require__.e(119), __webpack_require__.e(349), __webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(486), __webpack_require__.e(400)]).then(function() { return function() { return (__webpack_require__(6674)); }; });
	},
	"./pages-map": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map */ 19).then(function() { return function() { return (__webpack_require__(6142)); }; });
	},
	"./pages-map-v2": function() {
		return __webpack_require__.e(/* __federation_expose_pages_map_v2 */ 974).then(function() { return function() { return (__webpack_require__(7949)); }; });
	},
	"./pages/index": function() {
		return Promise.all(/* __federation_expose_pages__index */[__webpack_require__.e(119), __webpack_require__.e(349), __webpack_require__.e(884), __webpack_require__.e(775), __webpack_require__.e(486), __webpack_require__.e(814)]).then(function() { return function() { return (__webpack_require__(8933)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope, remoteEntryInitOptions) {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
	__webpack_require__.federation.isMFRemote = true;

	__webpack_require__.federation.isMFRemote = false;

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});